import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import './Css/ToDo.css'
import './Css/ToDo-responsive.css'

import { Ripple } from "primereact/ripple";
import { confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Nullable } from "primereact/ts-helpers";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { Paginator, PaginatorPageChangeEvent } from 'primereact/paginator';

import NoDataCreated from "../../Components/NoDataCreated";
import ErrorPage from "../../Components/ErrorPage";
import PageLoader from "../../Components/PageLoader";
import DatePicker from "../../Components/DatePicker";
import TextInput from "../../Components/TextInput";
import { goToTop } from "../../Components/goToTop";
import { formatDate, parseStringToDate } from "../../Utils/getDate";
import { checkText } from "../../Utils/Validator";

import { ToDoLists, ToDoListTasks } from "./SampleToDoListData";
import { PostTodoTask, PostTodoTitle, TodoTitle } from "../../Controllers/Types/Todo/TodoInterface";
import { createTodoTaskApi, createTodoTitleApi, deleteTodoTaskApi, deleteTodoTitleApi, updateStatusTodoTaskApi, updateTodoTitleApi } from "../../Api/Todo/TodoApi";
import { useAppDispatch, useAppSelector } from "../../Controllers/hooks";
import { getAllTodoData } from "../../Controllers/Thunks/todoThunks";
import { getProjectTenderDetailList } from "../../Controllers/Thunks/tenderThunks";
import { useSelector } from "react-redux";
import { RootState } from "../../Controllers/Store";
import { hasPermission } from "../../Controllers/Selectors/permissionsSelector";

const ToDo: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch()

    const today = new Date();
    const toast = useRef<Toast>(null);
    const [dataState, setDataState] = useState<'Add' | 'Edit'>('Add');
    const [loading, setLoading] = useState<boolean>(false);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [successMessage, setSuccessMessage] = useState<string>('');

    const [toDoListData, setToDoListData] = useState<ToDoLists[]>([]);
    const [filteredToDoListData, setFilteredToDoListData] = useState<ToDoLists[]>([]);
    const [paginatedToDoData, setPaginatedToDoData] = useState<ToDoLists[]>([]);
    const [dateFilter, setDateFilter] = useState<Nullable<Date>>(null);
    const [selectedDate, setSelectedDate] = useState<string>('');
    const [selectedToDoData, setSelectedToDoData] = useState<ToDoLists | null>(null);
    const [selectedTodoTitle, setSelectedTodoTitle] = useState<TodoTitle | null>(null);

    const [loadingDeleteTodoTask, setLoadingDeleteTodoTask] = useState<boolean>(false);


    /* For todo */
    const [showToDoModal, setShowToDoModal] = useState<boolean>(false);
    const [toDoTitle, setToDoTitle] = useState<string>('');
    const [toDoDueDate, setToDoDueDate] = useState<Nullable<Date>>(null);

    /* for error */
    const [toDoTitleError, setToDoTitleError] = useState<string>('');
    const [toDoDueDateError, setToDoDueDateError] = useState<string>('');

    /* For todo task */
    const [showToDoTaskModal, setShowToDoTaskModal] = useState<boolean>(false);
    const [toDoTask, setToDoTask] = useState<string>('');


    /* for error */
    const [toDoTaskError, setToDoTaskError] = useState<string>('');


    /* Pagination */
    const [first, setFirst] = useState<number>(0);
    const [rows, setRows] = useState<number>(8);

    const { loadingTodoTitles, errorTodoTitles, allTodoTitles } = useAppSelector((state) => state.todo);

    const useCanEdit = (screen: string, permission: string) => {
        return useSelector((state: RootState) => hasPermission(state, screen, permission));
    };

    const isPermissionAddTodoList = useCanEdit('Todo List', 'add_todo_list');
    const isPermissionEditTodoList = useCanEdit('Todo List', 'edit_todo_list');
    const isPermissionDeleteTodoList = useCanEdit('Todo List', 'delete_todo_list');

    const onPageChange = (event: PaginatorPageChangeEvent) => {
        setFirst(event.first);
        setRows(event.rows);
    };
    /*  */

    useEffect(() => {
        dispatch(getAllTodoData())
    }, []);


    useEffect(() => {
        setToDoListData(allTodoTitles);
        applyFilters();
        const paginatedData = filteredToDoListData.slice(first, first + rows);
        setPaginatedToDoData(paginatedData);

        if (selectedToDoData) {
            let filteredTask = allTodoTitles.filter(toDo => toDo?.todo_list_id === selectedToDoData.todo_list_id);
            if (filteredTask.length > 0) {
                setSelectedToDoData(filteredTask[0]);
            }
        }
    }, [allTodoTitles]);

    useEffect(() => {
        applyFilters();
    }, [selectedDate]);


    useEffect(() => {
        setFirst(0);
        setRows(8);

        const paginatedData = filteredToDoListData.slice(first, first + rows);
        setPaginatedToDoData(paginatedData);
    }, [filteredToDoListData]);


    useEffect(() => {
        const paginatedData = filteredToDoListData.slice(first, first + rows);
        setPaginatedToDoData(paginatedData);

    }, [first, rows]);

    const handleDateChange = (e: any) => {
        const selectedDate = e.value;
        setDateFilter(selectedDate || null);
        setSelectedDate(formatDate(selectedDate));
    };

    const applyFilters = () => {
        let filteredData = allTodoTitles;

        if (selectedDate) {
            filteredData = filteredData.filter(toDo => toDo?.deu_date === selectedDate);
        }
        setFilteredToDoListData(filteredData);
    }


    /* ******************************** For todo ********************************* */
    const handleCloseToDoModal = () => {
        setShowToDoModal(false);
    }

    const handleAddToDo = () => {
        setDataState('Add');
        setShowToDoModal(true);

        handleClearToDoFields();
        handleClearToDoError();
    }

    const handleCreateToDo = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsTodoTitle()) {
            setLoading(true);

            const toDoDueDatetring = formatDate(toDoDueDate || null);
            const USERID: string = localStorage.getItem('user_id') || "";

            const data: PostTodoTitle = {
                user_id: Number(USERID),
                title: toDoTitle,
                deu_date: toDoDueDatetring,
            }

            const res = await createTodoTitleApi(data)
            setLoading(false);
            if (res.status) {
                dispatch(getAllTodoData())

                setTimeout(() => {
                    setLoading(false);
                    setSuccessMessage('To do list added successfully.');
                    setShowAlert(true);
                    handleCloseToDoModal();
                    setTimeout(() => {
                        setSuccessMessage('');
                        setShowAlert(false);
                    }, 2000);
                }, 500);
            } else {
                setLoading(false);
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error creating to do.',
                        detail: 'There was an error creating to do.',
                        life: 3000
                    });
                }
            }
        }
    }

    const handleModifyToDo = (toDo: TodoTitle) => {
        setDataState('Edit');
        setShowToDoModal(true);

        setSelectedToDoData(toDo);
        setToDoTitle(toDo?.title);
        setToDoDueDate(parseStringToDate(toDo?.deu_date));
    }

    const handleUpdateToDo = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsTodoTitle()) {

            setLoading(true);
            const toDoDueDatetring = formatDate(toDoDueDate || null);

            const res = await updateTodoTitleApi(selectedToDoData?.todo_list_id!, toDoTitle, toDoDueDatetring);
            setLoading(false);

            if (res.status) {
                dispatch(getAllTodoData())

                setTimeout(() => {
                    setLoading(false);
                    setSuccessMessage('To do list updated successfully.');
                    setShowAlert(true);
                    handleCloseToDoModal();
                    setTimeout(() => {
                        setSuccessMessage('');
                        setShowAlert(false);
                    }, 2000);
                }, 500);
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error updating to do list.',
                        detail: 'There was an error updating to do list.',
                        life: 3000
                    });
                }
            }
        }
    }

    const handleClearToDoFields = () => {
        setToDoTitle('');
        setToDoDueDate(null);
    }

    const handleClearToDoError = () => {
        setToDoTitleError('');
        setToDoDueDateError('');
    }

    const handleDeleteToDoTitle = () => {
        confirmDialog({
            message: `Are you sure you want to delete the to do list?`,
            header: 'Confirm the deletion',
            icon: 'bi bi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            dismissableMask: true,
            resizable: false,
            draggable: false,
            accept: deleteToDoTitle,
        });
    }

    const deleteToDoTitle = async () => {
        const res = await deleteTodoTitleApi(selectedToDoData?.todo_list_id!);

        if (res.status) {
            dispatch(getAllTodoData())
            handleCloseToDoModal();
            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'To do list deleted successfully.',
                    life: 3000
                });
            }
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error deleting to do list.',
                    detail: 'There was an error deleting the to do list.',
                    life: 3000
                });
            }
        }
    }

    function checkCredentialsTodoTitle(): boolean {
        const todoTitleDateString = formatDate(toDoDueDate || null);

        const todoTitle = checkText(toDoTitle, true, setToDoTitleError);
        const todoTitleStringValid = checkText(todoTitleDateString, true, setToDoDueDateError);


        return todoTitle && todoTitleStringValid;
    }

    function checkCredentialsToDoTask(): boolean {
        const toDoTaskValidate = checkText(toDoTask, true, setToDoTaskError);

        return toDoTaskValidate;
    }

    /* Modal header */
    const toDoModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState === 'Add' ? 'Add title' : 'Edit list'}
            </h5>
            {dataState === 'Edit' ? (
                <React.Fragment>

                    {isPermissionDeleteTodoList && <button type="button" className="close_modal_btn p-ripple"
                        onClick={() => handleDeleteToDoTitle()}>
                        <i className="bi bi-trash3"></i>
                        <Ripple />
                    </button>}
                </React.Fragment>

            ) : (
                <button type="button" className="close_modal_btn p-ripple"
                    onClick={handleCloseToDoModal}>
                    <i className="bi bi-x-circle"></i>
                    <Ripple />
                </button>
            )}
        </div>
    );

    /* Modal footer */
    const toDoModalFooter = (
        <div className="custom_modal_footer">
            <Button label="Close" className="custom_btn secondary" onClick={handleCloseToDoModal} />
            <Button label={loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}
                onClick={dataState === 'Add' ? handleCreateToDo : handleUpdateToDo}
                loading={loading} className="custom_btn primary"
            />
        </div>
    );
    /* *************************************************************************** */


    /* ******************************* For todo task ****************************** */
    const handleCloseToDoTaskModal = () => {
        setShowToDoTaskModal(false);
    }

    const handleAddToDoTask = (todoTitle: TodoTitle) => {
        setSelectedTodoTitle(todoTitle)
        setShowToDoTaskModal(true);

        setToDoTask('');
        setToDoTaskError('');
    }

    const handleCreateToDoTask = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsToDoTask()) {
            setLoading(true);

            const data: PostTodoTask = {
                todo_list_id: selectedTodoTitle?.todo_list_id!,
                task: toDoTask,

            }

            const res = await createTodoTaskApi(data)
            setLoading(false);


            if (res.status) {
                dispatch(getAllTodoData())

                setTimeout(() => {

                    handleCloseToDoTaskModal();
                    if (toast.current) {
                        toast.current.show({
                            severity: 'success',
                            summary: 'Success',
                            detail: 'To do checklist added successfully.',
                            life: 3000
                        });
                    }
                }, 500);

            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error creating to do checklist.',
                        detail: 'There was an error creating to do checklist.',
                        life: 3000
                    });
                }
            }


        }





    }

    /* Modal header */
    const toDoTaskModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Add to do
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseToDoTaskModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    /* Modal footer */
    const toDoTaskModalFooter = (
        <div className="custom_modal_footer">
            <Button label="Close" className="custom_btn secondary" onClick={handleCloseToDoTaskModal} />
            <Button label={`${loading ? 'Processing' : 'Save'}`} onClick={handleCreateToDoTask} loading={loading} className="custom_btn primary" />
        </div>
    )

    const handleDeleteToDoTask = (task: ToDoListTasks) => {
        confirmDialog({
            message: `Are you sure you want to delete the to do task?`,
            header: 'Confirm the deletion',
            icon: 'bi bi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => deleteToDoTask(task),
        });
    }

    const deleteToDoTask = async (task: ToDoListTasks) => {
        setLoadingDeleteTodoTask(true)

        const res = await deleteTodoTaskApi(task!.todo_list_task_id)

        setLoadingDeleteTodoTask(false)

        if (res.status) {
            dispatch(getAllTodoData())

            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Task removed successfully.',
                    life: 3000
                });
            }
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error deleting task.',
                    detail: 'There was an error deleting the task.',
                    life: 3000
                });
            }
        }


    }

    const handleChangeToDoListTaskStatus = async (taskId: number) => {


        const res = await updateStatusTodoTaskApi(taskId);

        if (res.status) {
            dispatch(getAllTodoData())
            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Task status updated successfully.',
                    life: 3000
                });
            }
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error updating task status.',
                    detail: 'There was an error updating the task status.',
                    life: 3000
                });
            }
        }


    };

    /* *************************************************************************** */


    /* Common function */
    const handleCloseAlert = () => {
        setShowAlert(false);
    };

    const goBack = () => {
        navigate(-1);
        goToTop();
    };
    return (
        <React.Fragment>
            <Toast ref={toast} />

            <div className="main_content layout_padding show_side_bar">
                {loadingTodoTitles ? (
                    <PageLoader />
                ) : errorTodoTitles ? (
                    <ErrorPage errorMessage={errorTodoTitles} />
                ) : (
                    <div className="page_content mt-0">
                        <div className="d-flex align-items-center justify-content-between">
                            <h4 className="main_heading">To do list</h4>
                            <button className="back_btn p-ripple" onClick={goBack}>
                                <i className="bi bi-arrow-left me-2"></i>
                                Back
                                <Ripple />
                            </button>
                        </div>

                        <div className="page_header_area mt-sm-3 mt-3">
                            <div className="filter_option_group">
                                <div className="filter_date_input_group">
                                    <Calendar
                                        id='date'
                                        value={dateFilter}
                                        onChange={handleDateChange}
                                        dateFormat="dd M yy"
                                        maxDate={today}
                                        placeholder='Select date'
                                        className="custom_date_input filter_date_input custom_width"
                                        showIcon
                                        iconPos="left"
                                        icon="bi bi-calendar2-minus-fill"
                                        readOnlyInput
                                    />
                                    {dateFilter && <i className="bi bi-x date_clear_icon"
                                        onClick={() => {
                                            setDateFilter(null);
                                            setSelectedDate('');
                                        }}>
                                    </i>}
                                </div>
                            </div>

                            {isPermissionAddTodoList && <div className="page_action_area">
                                <button className="add_data_link_btn p-ripple"
                                    onClick={handleAddToDo}>
                                    <i className="bi bi-plus-circle"></i>
                                    <span>Add title</span>
                                    <Ripple />
                                </button>
                            </div>}
                        </div>

                        {paginatedToDoData?.length > 0 ? (
                            <div className="to_do_section">
                                {paginatedToDoData?.length > 0 ? (
                                    <div className="row to_do_row">
                                        {paginatedToDoData?.map((toDo) => {
                                            return (
                                                <div key={toDo?.todo_list_id} className="col-12 col-xl-4 col-xxl-3 col-sm-6 col-lg-6">
                                                    <article className="to_do_container">
                                                        <div className="to_do_header p-ripple" onClick={() => isPermissionEditTodoList ? handleModifyToDo(toDo) : null}>
                                                            <h6 className="text-capitalize">{toDo?.title}</h6>
                                                            <Ripple />
                                                            {isPermissionEditTodoList && <i className="bi bi-arrow-right"></i>}
                                                        </div>
                                                        <div className="to_do_body">
                                                            {toDo?.task.length > 0 ? (
                                                                <div className="to_do_list_area">
                                                                    {toDo?.task.map((task) => {
                                                                        return (
                                                                            <div key={task?.todo_list_task_id} className="to_do_list">
                                                                                <Checkbox
                                                                                    inputId={`task${task?.todo_list_task_id}`}
                                                                                    onChange={() => handleChangeToDoListTaskStatus(task.todo_list_task_id)}
                                                                                    checked={task.todo_list_task_status === 1}>
                                                                                </Checkbox>

                                                                                <label
                                                                                    htmlFor={`task${task?.todo_list_task_id}`}
                                                                                    className={`to_do_list_label text-capitalize ${task.todo_list_task_status === 1 ? 'done' : ''}`}
                                                                                >
                                                                                    <span>{task?.task}</span>
                                                                                </label>
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                            ) : (
                                                                <div className="empty_todo_list">
                                                                    <p>
                                                                        <i className="bi bi-exclamation-circle"></i>
                                                                        No tasks have been added yet.
                                                                    </p>
                                                                </div>
                                                            )}
                                                            {toDo?.task.length > 3 && (
                                                                <h6 className="excess_list">
                                                                    +{toDo?.task.length - 3}
                                                                </h6>
                                                            )}
                                                        </div>
                                                        {isPermissionAddTodoList && <div className="to_do_footer">
                                                            <button type="button" className="is_btn add_list_btn p-ripple"
                                                                onClick={() => handleAddToDoTask(toDo)}>
                                                                Add checklist
                                                                <i className="bi bi-plus-circle-fill ms-2"></i>
                                                                <Ripple />
                                                            </button>
                                                        </div>}
                                                    </article>
                                                </div>
                                            )
                                        })}
                                    </div>
                                ) : (
                                    <div className="page_main_content_section mt-0">
                                        <NoDataCreated
                                            message={`No data found!`}
                                        />
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="page_main_content_section">
                                <NoDataCreated
                                    message={`No to do have been added yet`}
                                />
                            </div>
                        )}

                        {filteredToDoListData?.length > 0 && (
                            <div className="pagination_area">
                                <Paginator
                                    first={first}
                                    rows={rows}
                                    totalRecords={filteredToDoListData.length}
                                    rowsPerPageOptions={[8, 16, 24]}
                                    onPageChange={onPageChange}
                                />
                            </div>
                        )}
                    </div>
                )}
            </div>


            {/* ToDo Modal */}
            <Dialog header={toDoModalHeader} footer={toDoModalFooter} headerClassName="custom_modal_header"
                visible={showToDoModal} className={`custom_modal_dialog modal_dialog_sm`}
                onHide={() => { if (!showToDoModal) return; setShowToDoModal(false); }}>
                <div className="custom_modal_body">
                    <div className="p-1 p-sm-3 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            <div className="col-12">
                                <TextInput
                                    id="toDoTitle"
                                    label="Title"
                                    labelHtmlFor="toDoTitle"
                                    required={true}
                                    value={toDoTitle}
                                    placeholder="Title"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setToDoTitle(e.target.value)}
                                    error={toDoTitleError}
                                />
                            </div>

                            <div className="col-12">
                                <DatePicker
                                    id="toDoDueDate"
                                    label="Due date"
                                    labelHtmlFor="toDoDueDate"
                                    required={true}
                                    value={toDoDueDate}
                                    placeholder="dd/mm/yyyy"
                                    onChange={setToDoDueDate}
                                    error={toDoDueDateError}
                                    showClear
                                    onClear={() => setToDoDueDate(null)}
                                />
                            </div>
                        </div>

                        {dataState === 'Edit' && (
                            <div className="row">
                                <div className="col-12">
                                    <div className="page_form_group">
                                        <label htmlFor="checkList" className="custom_form_label mb-2">Checklist</label>

                                        {loadingDeleteTodoTask ? (
                                            <React.Fragment></React.Fragment>
                                        ) : selectedToDoData?.task && selectedToDoData?.task.length > 0 ? (
                                            <React.Fragment>
                                                {selectedToDoData?.task.map((task) => {
                                                    return (
                                                        <div className="row mb-2">
                                                            <div className="col-10 pe-0">
                                                                <div key={task?.todo_list_task_id} className="to_do_list mb-0">
                                                                    <Checkbox
                                                                        inputId={`task${task?.todo_list_task_id}`}
                                                                        onChange={() => handleChangeToDoListTaskStatus(task.todo_list_task_id)}
                                                                        checked={task.todo_list_task_status === 1}>
                                                                    </Checkbox>

                                                                    <label
                                                                        htmlFor={`task${task?.todo_list_task_id}`}
                                                                        className={`to_do_list_label ${task.todo_list_task_status === 1 ? 'done' : ''}`}
                                                                    >
                                                                        <span>{task?.task}</span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="col-2 ps-0 d-flex align-items-center justify-content-end">
                                                                <button type="button" className="close_modal_btn dark p-ripple"
                                                                    onClick={() => handleDeleteToDoTask(task)}>
                                                                    <i className="bi bi-x-circle"></i>
                                                                    <Ripple />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </React.Fragment>
                                        ) : (
                                            <div className="empty_todo_list">
                                                <p>
                                                    <i className="bi bi-exclamation-circle"></i>
                                                    No tasks have been added yet.
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Dialog>


            {/* ToDo Task Modal */}
            <Dialog header={toDoTaskModalHeader} footer={toDoTaskModalFooter} headerClassName="custom_modal_header"
                visible={showToDoTaskModal} className={`custom_modal_dialog modal_dialog_sm`}
                onHide={() => { if (!showToDoTaskModal) return; setShowToDoTaskModal(false); }}>
                <div className="custom_modal_body">
                    <div className="p-1 p-sm-3 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            <div className="col-12">
                                <TextInput
                                    id="toDoTask"
                                    label="Add to do"
                                    labelHtmlFor="toDoTask"
                                    required={true}
                                    value={toDoTask}
                                    placeholder="Add to do"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setToDoTask(e.target.value)}
                                    error={toDoTaskError}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>


            {/* Show success message */}
            <div className={`message_backdrop ${showAlert ? 'show' : ''}`} onClick={handleCloseAlert}>
                <div className={`message_box ${showAlert ? 'show' : ''}`} onClick={e => e.stopPropagation()}>
                    <div className="message_box_content">
                        <i className="bi bi-check-circle-fill message_box_icon"></i>
                        <h6 className="message_box_message">
                            {successMessage}
                        </h6>
                    </div>
                </div>
            </div>
            {/*  */}
        </React.Fragment>
    )
}

export default ToDo;